import React from 'react';
import FsAvatarWithName from 'ui-elements/common-elements/FsAvatarWithName';
import {
  RowBox,
  Markers,
  SingleMarker,
} from './LeaderSingleRow.style-elements';

interface SingleMarkerProps {
  value: number;
  label: string;
}

export interface LeaderSingleRowDataProps {
  id: string | number;
  name: string;
  markers: SingleMarkerProps[];
}

export interface LeaderSingleRowProps extends LeaderSingleRowDataProps {
  isLast: boolean;
  avatarColor?: string;
}

const LeaderSingleRow: React.FC<LeaderSingleRowProps> = ({
  name,
  markers,
  isLast,
  avatarColor,
}) => {
  return (
    <RowBox isLast={isLast}>
      <FsAvatarWithName color={avatarColor}>{name}</FsAvatarWithName>
      <Markers>
        {markers.map(({ value, label }) => (
          <SingleMarker key={label}>
            <strong>{value}</strong> {label}
          </SingleMarker>
        ))}
      </Markers>
    </RowBox>
  );
};

export default LeaderSingleRow;
